import type { FaireProductEntity } from "../../entity_types/product";

export const p_7y3x7zjwzx: FaireProductEntity = {
  token: "p_7y3x7zjwzx",
  type: "product",
  name: "Unicorn Poop - Mini Bath Bombs- Gift Bag",
  brandToken: "b_9w42c3xo5a",
  brandName: "Happy Hippo Bath",
  imageUrl:
    "https://cdn.faire.com/fastly/e32e10cabc710b1d29f5b9e5184751cf2604a5068e95422ab14a75c13c46f42e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/edf8ffa0b6617512237cbebc2ed350381c4bdb541e7000ea49952f720b13eaf3.jpeg",
  ],
  priceDollars: 6.46,
  description:
    "Smells Like: Handmade candy & fresh berries\nSize: 175g of Tiny Bath-Time Magic\n\nWarning: Extreme fun ahead!\n\nToss in a few (or go all out and add a bunch!) and watch these mini bubble bombs fizz and pop with bright colors and tiny bubbles. They smell amazing and leave your skin feeling soft and happy.\n\nTake the fun out of the tub, too — drop them in a water table to make magical potions and experiment with mixing colors.\n",
  tags: [],
  msrpDollars: 13.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:44.225Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
